var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconShowMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-296.000000, -258.000000) translate(216.000000, 114.000000) translate(32.000000, 140.000000) translate(48.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 5.83l2.46 2.46c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L12.7 3.7c-.187-.187-.44-.292-.705-.292-.265 0-.518.105-.705.292L8.12 6.88c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L12 5.83zm0 12.34l-2.46-2.46c-.187-.187-.44-.292-.705-.292-.265 0-.518.105-.705.292-.39.39-.39 1.02 0 1.41l3.17 3.18c.39.39 1.02.39 1.41 0l3.17-3.17c.39-.39.39-1.02 0-1.41-.187-.187-.44-.292-.705-.292-.265 0-.518.105-.705.292L12 18.17z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShowMore);
export default __webpack_public_path__ + "static/media/icon-show-more.ad08e64dec5eeebba1989ca5f957709e.svg";
export { ForwardRef as ReactComponent };